import { r as s, h as t } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const o = ".sc-spam-icon-h{display:flex}", i = o, a = class {
  constructor(e) {
    s(this, e), this.width = "15", this.height = "15";
  }
  render() {
    return t("svg", { key: "e4b51898e2533ea3cd40a8b7a97fdd65e65a07fd", width: this.width, height: this.height, viewBox: "0 0 24 24", fill: "auto", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "203ee22867f877e1744ebcdaa1fd0ca084f8cb6b", d: "M20 3H4C2.89543 3 2 3.89543 2 5V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V5C22 3.89543 21.1046 3 20 3Z", stroke: "auto", "stroke-width": "1.5" }), t("path", { key: "8541a8d9c8dc64e909f6de9d58381ba10380b1f6", d: "M2 5L12 12.5L22 5", stroke: "auto", "stroke-width": "1.5" }));
  }
};
a.style = i;
export {
  a as spam_icon
};
